import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-042e169a")

_pushScopeId("data-v-042e169a")
const _hoisted_1 = { class: "CargoCharacteristics" }
const _hoisted_2 = { class: "CargoCharacteristics__header" }
const _hoisted_3 = { class: "header__title" }
const _hoisted_4 = {
  key: 0,
  class: "header__title__not-completed"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Заполните характеристики груза ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Характеристики груза")
const _hoisted_7 = { class: "CargoCharacteristics__body" }
const _hoisted_8 = { class: "CargoCharacteristics__pre-footer" }
const _hoisted_9 = { class: "vertical-group" }
const _hoisted_10 = { class: "vertical-group" }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "top-border" }, null, -1)
const _hoisted_13 = { class: "CargoCharacteristics__body" }
const _hoisted_14 = {
  key: 0,
  class: "CargoCharacteristics__error"
}
const _hoisted_15 = { class: "CargoCharacteristics__footer" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Подтвердить")
const _hoisted_17 = {
  key: 1,
  class: "CargoCharacteristics__body"
}
const _hoisted_18 = { key: 0 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_s_button = _resolveComponent("s-button")!
  const _component_i_close = _resolveComponent("i-close")!
  const _component_s_radio_group = _resolveComponent("s-radio-group")!
  const _component_multiselect = _resolveComponent("multiselect")!
  const _component_s_input = _resolveComponent("s-input")!
  const _component_s_text_area = _resolveComponent("s-text-area")!
  const _component_s_checkbox = _resolveComponent("s-checkbox")!
  const _component_file_loader = _resolveComponent("file-loader")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("h2", _hoisted_3, [
        (!_ctx.completed)
          ? (_openBlock(), _createBlock("div", _hoisted_4, [
              _hoisted_5,
              (_ctx.opened)
                ? (_openBlock(), _createBlock(_component_s_button, {
                    key: 0,
                    class: "primary",
                    onClick: _ctx.toggleInputs
                  }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.state.is_toggle_inputs_clicked
                                    ? 'Показать особые условия'
                                    : 'Скрыть особые условия'), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
              _hoisted_6
            ], 64))
      ]),
      (_ctx.completed && !_ctx.disabled)
        ? (_openBlock(), _createBlock(_component_i_close, {
            key: 0,
            class: "header__close",
            onClick: _ctx.emitReset
          }, null, 8, ["onClick"]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.opened)
      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
          (!_ctx.completed)
            ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                (!_ctx.isIntracity)
                  ? (_openBlock(), _createBlock(_component_s_radio_group, {
                      key: 0,
                      value: _ctx.form_state.shipment_type,
                      "onUpdate:value": [
                        _cache[1] || (_cache[1] = ($event: any) => (_ctx.form_state.shipment_type = $event)),
                        _ctx.onShipmentTypeChange
                      ],
                      options: _ctx.SHIPMENT_TYPE_OPTIONS,
                      theme: "red",
                      "is-horizontal": ""
                    }, null, 8, ["value", "options", "onUpdate:value"]))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_7, [
                  (_ctx.isAuto)
                    ? (_openBlock(), _createBlock(_component_multiselect, {
                        key: 0,
                        modelValue: _ctx.form_state.car_info.load_capacity,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form_state.car_info.load_capacity = $event)),
                        mode: "single",
                        loading: _ctx.data_state.capacity.is_loading,
                        options: _ctx.data_state.capacity.list,
                        object: true,
                        class: { invalid: _ctx.v$.car_info.load_capacity.$errors.length },
                        label: "load_capacity",
                        placeholder: "Грузоподъёмность машины",
                        onChange: _ctx.onCapacityChange,
                        disabled: _ctx.form_state.is_need_car
                      }, null, 8, ["modelValue", "loading", "options", "class", "onChange", "disabled"]))
                    : _createCommentVNode("", true),
                  (_ctx.isAuto)
                    ? (_openBlock(), _createBlock(_component_multiselect, {
                        key: 1,
                        modelValue: _ctx.form_state.car_info.cubature,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form_state.car_info.cubature = $event)),
                        mode: "single",
                        loading: _ctx.data_state.capacity.is_loading,
                        options: _ctx.data_state.capacity.list,
                        object: true,
                        class: { invalid: _ctx.v$.car_info.cubature.$errors.length },
                        label: "cubature",
                        placeholder: "Кубатура машин",
                        disabled: _ctx.form_state.is_need_car
                      }, null, 8, ["modelValue", "loading", "options", "class", "disabled"]))
                    : _createCommentVNode("", true),
                  (_ctx.isAuto)
                    ? (_openBlock(), _createBlock(_component_multiselect, {
                        key: 2,
                        modelValue: _ctx.form_state.car_info.loading_type,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.form_state.car_info.loading_type = $event)),
                        class: { invalid: _ctx.v$.car_info.loading_type.$errors.length },
                        options: _ctx.LOADING_TYPE_OPTIONS,
                        object: true,
                        label: "name",
                        placeholder: "Тип погрузки",
                        disabled: _ctx.form_state.is_need_car
                      }, null, 8, ["modelValue", "class", "options", "disabled"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_s_input, {
                    placeholder: "Вес",
                    value: _ctx.form_state.weight,
                    "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => (_ctx.form_state.weight = $event)),
                    "is-invalid": _ctx.v$.weight.$error
                  }, null, 8, ["value", "is-invalid"]),
                  _createVNode(_component_s_input, {
                    placeholder: "Длина",
                    value: _ctx.form_state.depth,
                    "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => (_ctx.form_state.depth = $event)),
                    "is-invalid": _ctx.v$.depth.$error
                  }, null, 8, ["value", "is-invalid"]),
                  _createVNode(_component_s_input, {
                    placeholder: "Ширина",
                    value: _ctx.form_state.width,
                    "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => (_ctx.form_state.width = $event)),
                    "is-invalid": _ctx.v$.width.$error
                  }, null, 8, ["value", "is-invalid"]),
                  _createVNode(_component_s_input, {
                    placeholder: "Высота",
                    value: _ctx.form_state.height,
                    "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => (_ctx.form_state.height = $event)),
                    "is-invalid": _ctx.v$.height.$error
                  }, null, 8, ["value", "is-invalid"]),
                  (!_ctx.state.is_toggle_inputs_clicked)
                    ? (_openBlock(), _createBlock(_component_s_input, {
                        key: 3,
                        value: _ctx.form_state.car_info.temperature_mode,
                        "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => (_ctx.form_state.car_info.temperature_mode = $event)),
                        placeholder: "Температурный режим",
                        disabled: _ctx.form_state.is_need_car
                      }, null, 8, ["value", "disabled"]))
                    : _createCommentVNode("", true),
                  (!_ctx.state.is_toggle_inputs_clicked || !_ctx.isNotRequired)
                    ? (_openBlock(), _createBlock(_component_s_input, {
                        key: 4,
                        placeholder: "Количество мест",
                        value: _ctx.form_state.places,
                        "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => (_ctx.form_state.places = $event)),
                        "is-invalid": _ctx.v$.places.$error
                      }, null, 8, ["value", "is-invalid"]))
                    : _createCommentVNode("", true),
                  (!_ctx.state.is_toggle_inputs_clicked)
                    ? (_openBlock(), _createBlock(_component_s_input, {
                        key: 5,
                        placeholder: "Страховка",
                        value: _ctx.form_state.insurance,
                        "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => (_ctx.form_state.insurance = $event))
                      }, null, 8, ["value"]))
                    : _createCommentVNode("", true),
                  (!_ctx.state.is_toggle_inputs_clicked && !_ctx.isIntracity)
                    ? (_openBlock(), _createBlock(_component_s_input, {
                        key: 6,
                        placeholder: "HS код",
                        value: _ctx.form_state.hs_code,
                        "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => (_ctx.form_state.hs_code = $event))
                      }, null, 8, ["value"]))
                    : _createCommentVNode("", true),
                  (!_ctx.state.is_toggle_inputs_clicked)
                    ? (_openBlock(), _createBlock(_component_s_input, {
                        key: 7,
                        placeholder: "Упаковка",
                        value: _ctx.form_state.packaging,
                        "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => (_ctx.form_state.packaging = $event))
                      }, null, 8, ["value"]))
                    : _createCommentVNode("", true),
                  (!_ctx.state.is_toggle_inputs_clicked)
                    ? (_openBlock(), _createBlock(_component_s_input, {
                        key: 8,
                        value: _ctx.form_state.client_price,
                        "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => (_ctx.form_state.client_price = $event)),
                        placeholder: "Цена клиента",
                        "is-invalid": _ctx.v$.client_price.$error
                      }, null, 8, ["value", "is-invalid"]))
                    : _createCommentVNode("", true),
                  (!_ctx.state.is_toggle_inputs_clicked)
                    ? (_openBlock(), _createBlock(_component_s_input, {
                        key: 9,
                        placeholder: "Особые условия",
                        value: _ctx.form_state.special_conditions,
                        "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => (_ctx.form_state.special_conditions = $event))
                      }, null, 8, ["value"]))
                    : _createCommentVNode("", true),
                  ((!_ctx.state.is_toggle_inputs_clicked || _ctx.isNotRequired) && _ctx.isAuto)
                    ? (_openBlock(), _createBlock(_component_multiselect, {
                        key: 10,
                        modelValue: _ctx.form_state.transport_type,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.form_state.transport_type = $event)),
                        mode: "single",
                        loading: _ctx.data_state.transport_types.is_loading,
                        options: _ctx.data_state.transport_types.list,
                        object: true,
                        label: "title",
                        placeholder: "Тип транспорта",
                        disabled: _ctx.form_state.is_need_car
                      }, null, 8, ["modelValue", "loading", "options", "disabled"]))
                    : _createCommentVNode("", true),
                  (!_ctx.state.is_toggle_inputs_clicked)
                    ? (_openBlock(), _createBlock(_component_multiselect, {
                        key: 11,
                        modelValue: _ctx.form_state.danger_class,
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.form_state.danger_class = $event)),
                        options: _ctx.data_state.danger_classes.list,
                        loading: _ctx.data_state.danger_classes.is_loading,
                        label: "title",
                        placeholder: "Класс опасности"
                      }, null, 8, ["modelValue", "options", "loading"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_s_text_area, {
                    placeholder: "Описание груза",
                    value: _ctx.form_state.description,
                    "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => (_ctx.form_state.description = $event)),
                    "is-invalid": _ctx.v$.description.$error,
                    height: 53,
                    "is-auto-resize": "",
                    disabled: _ctx.form_state.is_need_car
                  }, null, 8, ["value", "is-invalid", "disabled"]),
                  _createVNode(_component_s_input, {
                    value: _ctx.form_state.dop_order_number,
                    "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => (_ctx.form_state.dop_order_number = $event)),
                    placeholder: "Номер заказа клиента"
                  }, null, 8, ["value"])
                ]),
                _createVNode("div", _hoisted_8, [
                  _createVNode("div", _hoisted_9, [
                    _createVNode(_component_s_radio_group, {
                      value: _ctx.form_state.payment_method,
                      "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => (_ctx.form_state.payment_method = $event)),
                      options: _ctx.getPaymentMethods,
                      theme: "red"
                    }, null, 8, ["value", "options"])
                  ]),
                  _createVNode("div", _hoisted_10, [
                    _createVNode(_component_s_checkbox, {
                      label: "Негабарит",
                      value: _ctx.form_state.car_info.oversized_cargo,
                      "onUpdate:value": _cache[21] || (_cache[21] = ($event: any) => (_ctx.form_state.car_info.oversized_cargo = $event))
                    }, null, 8, ["value"]),
                    _createVNode(_component_s_checkbox, {
                      label: "Штабелируемый груз",
                      value: _ctx.form_state.is_stacked,
                      "onUpdate:value": _cache[22] || (_cache[22] = ($event: any) => (_ctx.form_state.is_stacked = $event))
                    }, null, 8, ["value"]),
                    (!_ctx.isIntracity)
                      ? (_openBlock(), _createBlock(_component_s_checkbox, {
                          key: 0,
                          label: "Таможенное оформление",
                          value: _ctx.form_state.customs_clearance,
                          "onUpdate:value": _cache[23] || (_cache[23] = ($event: any) => (_ctx.form_state.customs_clearance = $event))
                        }, null, 8, ["value"]))
                      : _createCommentVNode("", true),
                    (!_ctx.isIntracity)
                      ? (_openBlock(), _createBlock(_component_s_checkbox, {
                          key: 1,
                          label: "Без авто",
                          value: _ctx.form_state.is_need_car,
                          "onUpdate:value": _cache[24] || (_cache[24] = ($event: any) => (_ctx.form_state.is_need_car = $event)),
                          onChange: _ctx.onIsCarChange
                        }, null, 8, ["value", "onChange"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_s_checkbox, {
                      label: "Опасный груз",
                      value: _ctx.form_state.is_dangerous,
                      "onUpdate:value": [
                        _cache[25] || (_cache[25] = ($event: any) => (_ctx.form_state.is_dangerous = $event)),
                        _ctx.onIsDangerousChanged
                      ]
                    }, null, 8, ["value", "onUpdate:value"]),
                    (_ctx.form_state.is_dangerous)
                      ? (_openBlock(), _createBlock(_component_file_loader, {
                          key: 2,
                          class: "vertical-group__files",
                          value: _ctx.form_state.invoice_files,
                          "onUpdate:value": _cache[26] || (_cache[26] = ($event: any) => (_ctx.form_state.invoice_files = $event)),
                          placeholder: "Загрузите файл накладной",
                          "loaded-files-placeholder": "Файл накладной",
                          "is-invalid": _ctx.v$.invoice_files.$error,
                          accept: "all",
                          "is-multi-select": "",
                          "is-small": ""
                        }, null, 8, ["value", "is-invalid"]))
                      : _createCommentVNode("", true),
                    (_ctx.form_state.is_dangerous)
                      ? (_openBlock(), _createBlock(_component_file_loader, {
                          key: 3,
                          class: "vertical-group__files",
                          value: _ctx.form_state.certificate_of_safety_files,
                          "onUpdate:value": _cache[27] || (_cache[27] = ($event: any) => (_ctx.form_state.certificate_of_safety_files = $event)),
                          placeholder: "Загрузите сертификат безопасности",
                          "loaded-files-placeholder": "Сертификат безопасности",
                          "is-invalid": _ctx.v$.certificate_of_safety_files.$error,
                          accept: "all",
                          "is-multi-select": "",
                          "is-small": ""
                        }, null, 8, ["value", "is-invalid"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_s_checkbox, {
                      label: "Застраховать груз",
                      value: _ctx.form_state.isInsecure,
                      "onUpdate:value": _cache[28] || (_cache[28] = ($event: any) => (_ctx.form_state.isInsecure = $event)),
                      onChange: _ctx.onSecureChange
                    }, null, 8, ["value", "onChange"])
                  ])
                ]),
                (_ctx.form_state.isInsecure)
                  ? (_openBlock(), _createBlock("div", _hoisted_11, [
                      _hoisted_12,
                      _createVNode("div", _hoisted_13, [
                        _createVNode(_component_s_input, {
                          placeholder: "Объявленная стоимость",
                          value: _ctx.form_state.declared_price,
                          "onUpdate:value": _cache[29] || (_cache[29] = ($event: any) => (_ctx.form_state.declared_price = $event)),
                          "is-invalid": _ctx.v$.declared_price.$error
                        }, null, 8, ["value", "is-invalid"]),
                        _createVNode("div", null, [
                          _createVNode(_component_s_input, {
                            placeholder: "Наименование груза",
                            value: _ctx.form_state.cargo_name,
                            "onUpdate:value": _cache[30] || (_cache[30] = ($event: any) => (_ctx.form_state.cargo_name = $event)),
                            "is-invalid": _ctx.v$.cargo_name.$error
                          }, null, 8, ["value", "is-invalid"]),
                          (_ctx.form_state.cargo_name && _ctx.form_state.cargo_name.length < 3)
                            ? (_openBlock(), _createBlock("p", _hoisted_14, " Введите минимум 3 символа "))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_15, [
                  _createVNode(_component_s_button, {
                    class: "red",
                    onClick: _ctx.emitConfirm
                  }, {
                    default: _withId(() => [
                      _hoisted_16
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ], 64))
            : (_openBlock(), _createBlock("div", _hoisted_17, [
                _createVNode("span", null, "Грузоподъёмность машины: " + _toDisplayString(_ctx.form_state.car_info.load_capacity?.value), 1),
                (_ctx.form_state.car_info.cubature)
                  ? (_openBlock(), _createBlock("span", _hoisted_18, "Кубатура машины: " + _toDisplayString(_ctx.form_state.car_info.cubature.cubature), 1))
                  : _createCommentVNode("", true),
                _createVNode("span", null, "Тип погрузки: " + _toDisplayString(_ctx.form_state.car_info.loading_type?.name), 1),
                _createVNode("span", null, "Температурный режим: " + _toDisplayString(_ctx.form_state.car_info.temperature_mode), 1),
                _createVNode("span", null, "Вес: " + _toDisplayString(_ctx.form_state.weight), 1),
                _createVNode("span", null, "Длина: " + _toDisplayString(_ctx.form_state.depth), 1),
                _createVNode("span", null, "Ширина: " + _toDisplayString(_ctx.form_state.width), 1),
                _createVNode("span", null, "Высота: " + _toDisplayString(_ctx.form_state.height), 1),
                _createVNode("span", null, "Количество мест: " + _toDisplayString(_ctx.form_state.places), 1),
                _createVNode("span", null, "Страховка: " + _toDisplayString(_ctx.form_state.insurance), 1),
                _createVNode("span", null, "HS код: " + _toDisplayString(_ctx.form_state.hs_code), 1),
                _createVNode("span", null, "Упаковка: " + _toDisplayString(_ctx.form_state.packaging), 1),
                _createVNode("span", null, "Цена клиента: " + _toDisplayString(_ctx.form_state.client_price), 1),
                _createVNode("span", null, "Особые условия: " + _toDisplayString(_ctx.form_state.special_conditions), 1),
                _createVNode("span", null, "Тип транспорта: " + _toDisplayString(_ctx.form_state.transport_type ? _ctx.form_state.transport_type.title : ''), 1),
                _createVNode("span", null, "Класс опасности: " + _toDisplayString(_ctx.form_state.danger_class), 1),
                _createVNode("span", null, "Описание груза: " + _toDisplayString(_ctx.form_state.description), 1),
                _createVNode("span", null, "Наименование товара: " + _toDisplayString(_ctx.form_state.cargo_name), 1),
                _createVNode("span", null, "Объявленная стоимость: " + _toDisplayString(_ctx.form_state.declared_price), 1),
                _createVNode("span", null, "Номер заказа клиента: " + _toDisplayString(_ctx.form_state.dop_order_number || '-'), 1),
                _createVNode("span", null, "Метод оплаты: " + _toDisplayString(_ctx.form_state.payment_method.name), 1),
                _createVNode("span", null, "Тип доставки: " + _toDisplayString(_ctx.form_state.shipment_type.name), 1),
                _createVNode("span", null, "Негабарит: " + _toDisplayString(_ctx.form_state.car_info.oversized_cargo ? 'Да' : 'Нет'), 1),
                _createVNode("span", null, "Опасный груз: " + _toDisplayString(_ctx.form_state.is_dangerous ? 'Да' : 'Нет'), 1),
                _createVNode("span", null, "Штабелируемый груз: " + _toDisplayString(_ctx.form_state.is_stacked ? 'Да' : 'Нет'), 1),
                _createVNode("span", null, "Таможенное оформление: " + _toDisplayString(_ctx.form_state.customs_clearance ? 'Да' : 'Нет'), 1)
              ]))
        ], 64))
      : _createCommentVNode("", true)
  ]))
})